import {Pipe, PipeTransform} from '@angular/core';
import { Util } from '../controller/Util';

@Pipe({
    name: 'data',
    standalone: false
})
export class DataPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        //verificar se o valor será um objeto Date ou String, Sendo Date, conferte em string
        if(typeof(value) === 'object') value = Util.dataParaStringComZero(value)

        if (value === undefined || value === null) return ''

        if(value.toString().includes('T')) {
            value = value.replace(/T.+/, '')
        }

        if (value.toString().length === 10)
            return value.toString().split('-').reverse().join('/')
        if (value.toString().length === 23)
            return value.toString().substring(0, 10).split('-').reverse().join('/')
        if (value.toString().length === 19) {
            return value.toString().substring(0, 10).split('-').reverse().join('/')
        } else {
            return value
        }
    }
}